import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { useNavigate } from 'react-router-dom';
import type { Message } from '../../store/chatStore';

interface ChatMessageProps {
  message: Message;
}

export function ChatMessage({ message }: ChatMessageProps) {
  const navigate = useNavigate();
  const isUser = message.role === 'user';

  const handleSuggestionClick = (suggestion: any) => {
    if (suggestion.type === 'navigate' && suggestion.path) {
      navigate(suggestion.path);
    } else if (suggestion.type === 'message') {
      // Trigger sending this message
      const event = new CustomEvent('send-suggested-message', {
        detail: { message: suggestion.text }
      });
      window.dispatchEvent(event);
    } else if (suggestion.type === 'show_contacts') {
      // Show contacts modal or navigate
      alert('Контакты:\nТелефон: +7 (XXX) XXX-XX-XX\nАдрес: ...');
    }
  };

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-4`}>
      <div className={`max-w-[80%] ${isUser ? 'order-1' : 'order-2'}`}>
        {/* Message bubble */}
        <div
          className={`rounded-2xl px-4 py-3 ${
            isUser
              ? 'bg-emerald-600 text-white rounded-br-sm'
              : 'bg-gray-100 text-gray-900 rounded-bl-sm'
          }`}
        >
          <p className="whitespace-pre-wrap break-words">{message.content}</p>
        </div>

        {/* Timestamp */}
        <p className={`text-xs text-gray-500 mt-1 ${isUser ? 'text-right' : 'text-left'}`}>
          {format(message.timestamp, 'HH:mm', { locale: ru })}
        </p>

        {/* Suggestions (only for assistant messages) */}
        {!isUser && message.suggestions && message.suggestions.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {message.suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="px-3 py-2 bg-white border-2 border-emerald-500 text-emerald-700 rounded-lg text-sm font-medium hover:bg-emerald-50 transition-colors"
              >
                {suggestion.text}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
